import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=4f7ee403&"
import script from "./Target.vue?vue&type=script&lang=js&"
export * from "./Target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports